import Grid2 from '@mui/material/Unstable_Grid2';
import React, { useState } from 'react';

import Dropdown from '@/components/BaseLibrary/Dropdown/Dropdown';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import useGlobalStyles from '@/styles/global.styles';
import { ActionDropdownCF } from '@/types';

import useStyles from './ActionDropdown.styles';

export interface ActionDropdownContentProps {
  content: ActionDropdownCF;
}

export default function ActionDropdown({
  content: {
    fields: { headline, subhead, label, placeholder, links },
  },
}: ActionDropdownContentProps): React.JSX.Element {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles();
  const [selectedLink, setSelectedLink] = useState<string>('');

  const linkMap: Record<string, string> = links.reduce(
    (acc: Record<string, string>, link): Record<string, string> => {
      if (link?.fields?.url && link?.fields?.text) {
        acc[link.fields.text] = link.fields.url;
      }
      return acc;
    },
    {}
  );

  const sortedOptions = Object.keys(linkMap).sort((a, b) => a.localeCompare(b));

  const handleSelectChange = (selectedTitle: string) => {
    setSelectedLink(selectedTitle);
    const selectedOption = linkMap[selectedTitle];
    if (selectedOption) {
      // Legacy pages are external links so can't use router.push
      window.location.href = selectedOption;
    }
  };

  return (
    <SpacingContainer>
      <GridContainer2 gridProps={{ className: classes.wrapper }} fixed>
        <Grid2 xs={12} md={6}>
          {headline && <h1 className={classes.title}>{headline}</h1>}
          {subhead && (
            <p className={cx(globalClasses.body2, classes.subtitle)}>
              {subhead}
            </p>
          )}
        </Grid2>
        <Grid2 xs={12} md={6}>
          <Dropdown
            onChange={handleSelectChange}
            options={sortedOptions}
            defaultOption={selectedLink}
            placeholder={placeholder}
            hideLabel={!label}
            label={label || ''}
          />
        </Grid2>
      </GridContainer2>
    </SpacingContainer>
  );
}
